import processAriaDigits from './processAriaDigits.js';

tinymce.PluginManager.add('numdigit', function (editor) {
	editor.on('PostProcess', function (evt) {
		if (!evt.is_removing) {
			evt.content = processAriaDigits(evt.content);
		}
	});
});
